// Next.js Image component replacement
import React, { forwardRef } from "react";

const Image = forwardRef<
  HTMLImageElement,
  React.ImgHTMLAttributes<HTMLImageElement> & {
    fill?: boolean;
    priority?: boolean;
    quality?: number;
    placeholder?: "blur" | "empty";
    blurDataURL?: string;
    unoptimized?: boolean;
  }
>(
  (
    {
      fill,
      priority,
      quality,
      placeholder,
      blurDataURL,
      unoptimized,
      alt = "",
      ...props
    },
    ref
  ) => {
    const style = fill
      ? {
          position: "absolute" as const,
          height: "100%",
          width: "100%",
          inset: 0,
          objectFit: "cover" as const,
          ...props.style,
        }
      : props.style;

    return (
      <img
        ref={ref}
        alt={alt}
        {...props}
        style={style}
        loading={priority ? "eager" : "lazy"}
      />
    );
  }
);

Image.displayName = "Image";

export default Image;
export { Image };
